import { formatRecordData } from '../utils/utilities'
import MemoryStore from '../utils/memory-store'
import GatewayAdaptersFormContainer from '../gateway-adapters/containers/gateway-adapters-form-container'
import Enums from '../utils/enums'

export const filterViewData = (viewData, searchFilter) => {
  searchFilter = searchFilter.toLowerCase()

  if (searchFilter === '') {
    return viewData
  } else {
    return viewData.filter(t =>
      (
        (t.data.name.toLowerCase().indexOf(searchFilter) > -1) ||
        (t.data.url.toLowerCase().indexOf(searchFilter) > -1) ||
        (t.data.description.toLowerCase().indexOf(searchFilter) > -1)
      )
    )
  }
}

export const filterMappings = (data, searchFilter, callback) => {
  searchFilter = searchFilter.toLowerCase()

  if (searchFilter === '') {
    return callback(data)
  } else {
    return callback(data.filter(t =>
      (
        (t.name.toLowerCase().indexOf(searchFilter) > -1) ||
        (t.description.toLowerCase().indexOf(searchFilter) > -1) ||
        (t.endpoint.toLowerCase().indexOf(searchFilter) > -1) ||
        (t.targetedEndpoint.toLowerCase().indexOf(searchFilter) > -1)
      )
    ))
  }
}

export const formatRecord = (entry, data) => {
  let tempIndex = 0

  entry = formatRecordData(entry)
  entry.data.isActiveDescription = entry.data.isActive ? 'Yes' : 'No' // Needed for View Column

  if (entry.custom.isNewDoc) {
    // Add new Entry to State
    entry.custom.isNewDoc = false
    entry.custom.action = 'create'
    data.push(entry)
  } else {
    if (entry.custom.isSavedDoc) {
      entry.custom.action = 'update'
    } else {
      entry.custom.action = 'create'
    }

    // Update Entry in State
    tempIndex = data.findIndex(t => t._id === entry._id)
    data[tempIndex] = entry
  }

  return data
}

export const createCopy = (currEntryData, callback) => {
  const newEntry = JSON.parse(JSON.stringify(MemoryStore.gatewayadapters.dataTemplate))
  newEntry._id = new Date().getTime().toString()
  newEntry.custom.tempId = newEntry._id

  const entryData = JSON.parse(JSON.stringify(currEntryData))
  const tabType = Enums.VALUES_STRINGS.FORM
  const content = GatewayAdaptersFormContainer
  const closable = true
  const key = newEntry._id
  const app = Enums.APP_IDS.GATEWAY_ADAPTERS

  let title = Enums.APP_PROFILE_TITLES.gatewayadapters + Enums.VALUES_STRINGS.COLON + Enums.VALUES_STRINGS.SPACE
  let payload = {}

  // create unique key
  entryData.key = currEntryData.key + '_copy'
  entryData.name = currEntryData.name + ' (Copy)'

  newEntry.data = entryData

  title += entryData.key

  payload = {
    content,
    title,
    key,
    app,
    tabType,
    closable
  }

  MemoryStore.activeEntries[newEntry._id] = newEntry

  callback(payload)
}
